/**
 * ElementUI npm i element-ui -S
 * */
import ElementUI from 'element-ui'
import Clipboard from 'clipboard'

let commons = {};

/**
 * 复制
 * data复制的数据，
 * obj按钮id
 * */
commons.copy = function  copeLink(data, obj) {
  let copy = data;
  let clipboard = new Clipboard(obj, {
    text: function () {
      return copy;
    }
  });
  clipboard.on('success', function (e) {
    clipboard.destroy()
    ElementUI.Message({
      showClose: true,
      message: localStorage.getItem('lang') === 'en' ? 'Replicating Success' : '复制成功',
      type: 'success',
      duration: 1000,
      offset: 300
    });
  });
};
/**
 * 提示弹窗
 * tip提示内容
 * */
commons.popup = function popups(tip) {
  ElementUI.MessageBox(tip, '提示', {
    showClose: true,
    confirmButtonText: that.languageId === 1 ? '确定' : 'confirm',
    callback: action => {
    }
  })
};

/**
 * 日期格式化
 * fmt格式如：yyyy-MM-dd
 * date日期
 * */
commons.formatTime = function dateFtt(time) {
  let dateee = new Date(time).toJSON();
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
};

// 加密
commons.encode = function encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
};

// 解密
commons.decode = function decode(str) {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
};

// 手机校验
commons.judgePhone = function judgePhone(value) {
  let pPattern = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return !pPattern.test(value);
}

// 电话/手机校验
commons.judgeAllPhone = function judgePhone(type,value) {
  let pPattern = /^[1][3,4,5,6,7,8][0-9]{9}$/;
  let phPattern = /^[0][1-9]{2,3}-[0-9]{5,10}$/;
  let all = /^((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/
  if (type===0){
    return !pPattern.test(value);
  }else if (type===1){
    return !phPattern.test(value);
  }else {
    return !all.test(value);
  }
}
// 电话
/**
 * 判断电话号码是否符合格式
 * @param {string} value - 要判断的电话号码
 * @returns {boolean} - 如果电话号码符合格式，返回 true；否则返回 false
 * 
 * @example
 * // 返回 true
 * commons.judgeLandline('021-12345678');
 * commons.judgeLandline('075512345678');
 * commons.judgeLandline('5925179900');
 * 
 * @example
 * // 返回 false
 * commons.judgeLandline('12345678');
 * commons.judgeLandline('02112345678');
 */
commons.judgeLandline = function judgePhone(value) {
  let phPattern = /^0[1-9]{2,3}-?[0-9]{5,10}$|^[1-9][0-9]{4,10}$/;
  return !phPattern.test(value)
}


// 名称校验（中文或英文）
commons.judgeName = function judgeName(value) {
  let nPattern = /^[\u4e00-\u9fa5]{0,}$/;
  let ePattern = /^[a-zA-Z]$/;
  return nPattern.test(value) || ePattern.test(value);
}

// 名称校验（中文英文数字）
commons.judgeInfo = function judgeInfo(value) {
  let nPattern = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
  return !nPattern.test(value);
}

// 邮箱校验
commons.judgeEmail = function judgeEmail(email) {
  let emPattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z0-9]{2,6}$/;
  return !emPattern.test(email);
}

commons.judgePwd = function judgePwd(password) {
  let pattern = /^[0-9]*$/
  return !pattern.test(password);
}

commons.judgeCard = function judgeCard(card) {
  let cpattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return !cpattern.test(card);
}
//验证车牌号
commons.judgeCarID = function judgeCarID(id) {
  let idParren = /^([京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][1-9DF][1-9ABCDEFGHJKLMNPQRSTUVWXYZ]\d{3}[1-9DF]|[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5})$/
  return !idParren.test(id);
}

// 调整大屏字体
commons.fontSize = function fontSize(res) {
  let docEl = document.documentElement,
    clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (!clientWidth) return;
  let fs = 100 * (clientWidth / 1920);
  return res * fs;
}

/**
 * 对数字保留指定位数小数时，不足指定位数时自动补0
 * @param {Number | String} num - 源数据，可以是数字或字符串类型的数字
 * @param {Number} precision - 保留的小数位数，默认为2
 * @param {Boolean} [isFill = true] - 是否补零
 * @returns {string} - 返回保留指定位数小数的字符串
 */
commons.priceToFixed = function (num, precision = 2, isFill = true) {
  try {
    if (!num) return num;

    num = num.toString(); // 转成字符串类型

    const isNum = /^-?\d+(\.\d+)?(e[+-]?\d+)?$/i; // 判断是否为普通数字或科学计数法表示的数字
    if (!isNum.test(num)) return num;

    // 如果是科学计数法，先转换为普通数字
    if (num.toLowerCase().includes("e")) {
      num = Number(num).toFixed(precision); // 转换成普通数字并保留指定位数小数
      return num; // 科学计数法处理后直接返回结果
    }

    if (num.indexOf(".") !== -1) {
      let newVal = num.split(".");
      if (newVal[1].length < precision) {
        // 如果小数部分位数不足 precision 位，补零
        while (newVal[1].length < precision) {
          newVal[1] += "0";
        }
        num = newVal.join(".");
      } else if (newVal[1].length > precision) {
        // 如果小数部分超过 precision 位，四舍五入
        num = Number(num).toFixed(precision);
      }
    } else {
      // 如果是整数且需要补零
      if (isFill) {
        num += `.${"0".repeat(precision)}`;
      }
    }
    return num;
  } catch (e) {
    console.error(e);
    return num;
  }
};

/**
 * 首字母大写转换
 * @param string
 * @return {string}
 */
commons.capitalizeFirstLetter = function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// 防抖
commons.throttle = function (fn, gapTime) {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500
  }
  let _lastTime = null
  return function () {
    let _nowTime = +new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      // 将this和参数传给原函数
      fn.apply(this, arguments)
      _lastTime = _nowTime
    }
  }
}
/**
 * 根据年月获取完整的日期
 * @param {string} yearMonth - 年月字符串，格式为 'yyyy-MM'
 * @param {boolean} isFirstDay - 是否是月份的第一天,当传入的年月与当前年月相同时，我们需要特殊处理，确保最后一天只能是今天。
 * @returns {string} 完整的年月日日期字符串
 */
commons.getCompleteDate = function (yearMonth, isFirstDay) {
  const [year, month] = yearMonth.split('-');
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  if (parseInt(year) === currentYear && parseInt(month) === currentMonth && !isFirstDay) {
    const today = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${today}`;
  } else {
    const day = isFirstDay ? '01' : new Date(year, month, 0).getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
/**
 * 获取近七天日期数组 ['yyyy-MM-dd', 'yyyy-MM-dd']
 * @returns {Array} 近七天日期数组
 */
commons.getLast7Day = function() {
  // 使用getDateArray方法获取上一个月的第一天和最后一天
  // 获取当前时间
  const now = new Date();
  // 计算前两天的日期
  const twoDaysAgo = new Date(now);
  twoDaysAgo.setDate(now.getDate() - 2);
  // 计算9天前的日期
  const sevenDaysLater = new Date(twoDaysAgo);
  sevenDaysLater.setDate(twoDaysAgo.getDate() - 6);
  return [
    commons.formatTime(sevenDaysLater).split(' ')[0],
    commons.formatTime(twoDaysAgo).split(' ')[0]
  ];
}
export default commons





// WEBPACK FOOTER //
// ./src/utils/common.js